import { Link } from "react-router-dom";
import { useContext } from "react";
import { PatentContext } from "../context/PatentContextProvider";

export default function QuestionsAnswers({ faqs }) {
  const { handleLinkClick } = useContext(PatentContext);

  return (
    <>
      {faqs.map((faq, index) => {
        const aboutUsIndex = faq.answer.indexOf("About Us");

        if (aboutUsIndex !== -1) {
          const beforeText = faq.answer.substring(0, aboutUsIndex);
          const afterText = faq.answer.substring(aboutUsIndex + "About Us".length);

          return (
            <div key={index} className="pb-8 sm:pb-6 md:pb-8">
              <h3 className="text-[#212529] font-bold pb-2 text-xl sm:text-2xl md:text-3xl">
                {faq.question}
              </h3>
              <p className="text-base sm:text-lg md:text-xl leading-relaxed">
                {beforeText}

                <Link
                  to="/about-us"
                  onClick={() => handleLinkClick("/about-us")}
                  className="text-blue-500 font-semibold"
                >
                  About Us
                </Link>

                {afterText}
              </p>
            </div>
          );
        }
        return (
          <div key={index} className="pb-8 sm:pb-6 md:pb-8">
            <h3 className="text-[#212529] font-bold pb-2 text-xl sm:text-2xl md:text-3xl">
              {faq.question}
            </h3>
            <p className="text-base sm:text-lg md:text-xl leading-relaxed">
              {faq.answer}
            </p>
          </div>
        );
      })}
    </>
  );

}